import { render } from "./FooterComp.vue?vue&type=template&id=2ece2478"
import script from "./FooterComp.vue?vue&type=script&lang=js"
export * from "./FooterComp.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/SPINcrs-demo/SPINcrs-demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__